/* lp-reasons — <lp-reasons>: the desktop reason list. On ≥ 48rem with 2+ steps it sets data-list (the CSS lays the titles
   out beside one photo), makes each title a button (Enter / Space) and marks the open step .is-active and the ones
   before it .is-past. A click anywhere on a reason opens it. Starts on the first reason; nothing is tied to
   scrolling. Below 48rem everything is removed and the stacked list shows. Theme editor: selecting a reason block
   opens it. */
(function () {
  'use strict';
  if (window.customElements.get('lp-reasons')) return;
  var DESKTOP = window.matchMedia('(min-width: 48rem)');

  class LpReasons extends HTMLElement {
    connectedCallback() {
      var self = this;
      if (this.getAttribute('data-layout') === 'stack') return; /* stacked: plain list, nothing to drive */
      this.steps = Array.prototype.slice.call(this.querySelectorAll('[data-lp-step]'));
      if (this.steps.length < 2) return;
      this.texts = this.steps.map(function (s) { return s.querySelector('[data-lp-text]'); });
      this.heads = this.steps.map(function (s) { return s.querySelector('[data-lp-head]'); });
      this.index = 0;
      this.onClick = function (e) {
        if (!self.list) return;
        var t = e.target.closest('[data-lp-text]');
        var k = self.texts.indexOf(t);
        if (k > -1) self.show(k);
      };
      this.onKey = function (e) {
        if (!self.list || (e.key !== 'Enter' && e.key !== ' ')) return;
        var k = self.heads.indexOf(e.target);
        if (k < 0) return;
        e.preventDefault();
        self.show(k);
      };
      this.onMode = function () { self.setMode(); };
      this.onSelect = function (e) {
        var k = self.steps.indexOf(e.target);
        if (k > -1) self.show(k);
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', this.onMode); else DESKTOP.addListener(this.onMode);
      document.addEventListener('shopify:block:select', this.onSelect);
      this.setMode();
    }
    disconnectedCallback() {
      if (!this.onMode) return;
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
      if (DESKTOP.removeEventListener) DESKTOP.removeEventListener('change', this.onMode); else DESKTOP.removeListener(this.onMode);
      document.removeEventListener('shopify:block:select', this.onSelect);
    }
    setMode() {
      var on = DESKTOP.matches;
      if (on === !!this.list) return;
      this.list = on;
      var self = this;
      this.heads.forEach(function (h, k) {
        if (!h) return;
        var more = self.steps[k].querySelector('.lp-reasons__more');
        if (on) {
          h.setAttribute('role', 'button');
          h.setAttribute('tabindex', '0');
          if (more) h.setAttribute('aria-controls', more.id);
        } else {
          h.removeAttribute('role'); h.removeAttribute('tabindex'); h.removeAttribute('aria-controls'); h.removeAttribute('aria-expanded');
        }
      });
      if (!on) {
        this.removeAttribute('data-list');
        this.removeAttribute('data-ready');
        this.steps.forEach(function (s) { s.classList.remove('is-active', 'is-past'); });
        return;
      }
      this.setAttribute('data-list', '');
      this.paint();
      /* commit the first state before switching transitions on, so nothing animates into place */
      void this.offsetHeight;
      this.setAttribute('data-ready', '');
    }
    show(i) {
      if (i === this.index) return;
      this.index = i;
      if (this.list) this.paint();
    }
    paint() {
      var i = this.index, heads = this.heads;
      this.steps.forEach(function (s, k) {
        s.classList.toggle('is-active', k === i);
        s.classList.toggle('is-past', k < i);
        if (heads[k]) heads[k].setAttribute('aria-expanded', k === i ? 'true' : 'false');
      });
    }
  }
  window.customElements.define('lp-reasons', LpReasons);
})();
